import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ConsoleApp } from './components/ConsoleApp';
import { LoginPage } from './components/LoginPage';
import { isAuthenticated } from './lib/auth';
import './styles/app.css';

export default function App() {
  const [ready, setReady] = useState(false);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    isAuthenticated().then((ok) => {
      setAuthed(ok);
      setReady(true);
    });
  }, []);

  if (!ready) return <div className="empty">Avvio…</div>;

  if (!authed) {
    return <LoginPage onOk={() => setAuthed(true)} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ConsoleApp onLogout={() => setAuthed(false)} />} />
        <Route path="/tickets/:ticketId" element={<ConsoleApp onLogout={() => setAuthed(false)} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
